import * as fetchActions from './Fetch';
import * as apiUrls from './ExternalApiUrls';
import {API_URL} from './ApiSettings';

export async function GetCaptchaSiteKey() {
    return await GetSettingValue("CaptchaSiteKey");
}

export async function GetAllowMultiplePositionsForComplaintSetting() {
    return await GetSettingValueAsBool("AllowMultiplePositionsForComplaint");
}

export async function GetIsMyCompanyNotFoundCheckBoxVisibleSetting() {
    return await GetSettingValueAsBool("IsMyCompanyNotFoundCheckBoxVisible");
}

export async function GetIsSerialNumberTooltipVisibleSetting() {
    return await GetSettingValueAsBool("IsSerialNumberTooltipVisible");
}

export async function GetCompaniesByTax(taxId) {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_COMPANIES_BY_TAX}${taxId}`);
}

export async function GetComplaintPositionComponents() {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_COMPLAINT_POSITION_COMPONENTS}`);
}

export async function GetCompaniesByText(text) {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_COMPANIES_BY_TEXT}${text}`);
}

export async function GetComplaintById(id) {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_COMPLAINT_BY_ID}${id}`);
}

export async function GetComplaintByNumber(complaintRequest) {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_COMPLAINT_BY_NUMBER}number=${complaintRequest.number}&password=${complaintRequest.password}`);
}

export async function GetCouriers() {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_COURIERS}`);
}

export async function GetComplaintsTypes(customerTypeId) {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_COMPLAINT_TYPES}customerTypeId=${customerTypeId}`);
}

export async function GetCustomerTypes() {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_CUSTOMER_TYPES}`);
}

export async function GetProductsByText(text, complaintType) {
    let url = apiUrls.GET_PRODUCTS_BY_TEXT;
    url = url.replace("{text}", text);
    url = url.replace("{complaintType}", complaintType);
    return await fetchActions.FetchData(`${API_URL}${url}`);
}

export async function GetQuantityCorrectionsProposals() {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_QUANTITY_CORRECTIONS_PROPOSAL}`);
}

export async function GetSettingValue(settingKey) {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_SETTING_VALUE}${settingKey}`);
}

export async function GetSettingValueAsBool(settingKey){
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_SETTING_AS_BOOL_VALUE}${settingKey}`);
}

export async function GetTermOfUseURL() {
    return await GetSettingValue("URLForTermOfUse");
}

export async function IssueComplaint(complaint) {
    return await fetchActions.FetchPost(`${API_URL}${apiUrls.POST_COMPLAINT}`,complaint);
}

export async function UpdateComplaintWaybillNumber(requestModel) {
    return await fetchActions.FetchPut(`${API_URL}${apiUrls.PUT_COMPLAINT_WAYBILL_NUMBER}`,requestModel);
}

export async function ValidateCaptcha(captchaResponse) {
    return await fetchActions.FetchPost(
        `${API_URL}${apiUrls.VALIDATE_CAPTCHA}`,
        { captchaResponse: captchaResponse }
    );
}

export async function GetTexts() {
    return await fetchActions.FetchData(`${API_URL}${apiUrls.GET_TEXTS}`);
}

export async function GetSalesDocumentNumberId(salesDocumentNumber, customerId) {
    let url = apiUrls.GET_SALES_DOCUMENT_ID_BY_NUMBER_AND_CUSTOMER_ID;
    url = url.replace("{salesDocumentNumber}", salesDocumentNumber);
    url = url.replace("{customerId}", customerId);
    return fetchActions.FetchData(`${API_URL}${url}`);
}




// WEBPACK FOOTER //
// ./src/api/ApiCalls.js